import SeoHead from '../../components/SeoHead';
import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import Clients from '../../components/Clients';
import LatestJobs from '../../components/LatestJobs';
import SpecialismDetail from '../../components/SpecialismDetail';
import Header from '../../components/MainHeader';
import SimplePage from '../../components/SimplePage';
import OurValues from '../../components/OurValues';
import TextWithCTA from '../../components/TextWithCTA';

export default function IndividualJobsearchByClient({
    global,
    page,
    all_clients,
    all_jobs,
    all_sub_specialisms
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${page.title} | Gap Personnel`}
                // description={``}
                canonical_link={`/clients/${page.url_slug}/`}
            />
            <Header
                employerNav={false}
                slug_url={`${page.url_slug}`}

            />
            <SubBanner
                global={global}
                pathPrefix={`client_page.sub_banner`}
                customClass={`mb-5 pb-5 secondary-banner`}
                buttonTitle={`Job search by client`}
                buttonLink={`/job-search-by-client/`}
                consultantPage={false}
                heading={`${page.title}`}
                post={page}
                bannerImageAlt={`${page.title} Banner Image`}
                bannerImageAlt2={`${page.title} Banner Image 2`}
                bannerImage={`${page.image ? page.image : "/site-assets/images/image-placeholder.webp"}`}
                bannerImage2={`${page.secondary_image ? page.secondary_image : "/site-assets/images/image-placeholder.webp"}`}
                dualBannerImage={true}
                logoBanner={true}
            />
            <TextWithCTA
                global={global}
                pathPrefix={`client_page.text_with_cta`}
                customClass={`mt-5 mb-5 pb-lg-5`}
                link1={`/job-seekers-get-in-touch`}
                link2={`/recruit-staff/`}
                column1={true}
                column2={false}
                buttonTitle1={
                    <>
                        <strong>
                            Get a callback
                        </strong> and we'll help you find your next role
                    </>
                }
                buttonTitle2={
                    <>
                        <strong>
                            Recruit staff
                        </strong> let us help your fill your next role
                    </>
                }
                fullWidth={true}
                mainButtonTitle1={`Get in touch`}
                mainButtonLink1={`/job-seekers-get-in-touch/`}
            />
            <OurValues
                global={global}
                pathPrefix={`client_page.our_values`}
                customClass='mt-lg-5 mb-5 pt-lg-5 pb-lg-5 primaryColor'
                sub_heading_1={``}
                sub_heading_2={``}
                sub_heading_3={``}
                content_1={`Driver CPC training aims to enhance road safety, improve driver skills, and ensure professional standards amongst commercial drivers.`}
                content_2={`All our drivers have already obtained their initial Driver CPC qualification, having completed a theory test, practical driving test, and a case study test, and undertaking 35 hours of periodic training every 5 years to maintain their qualification.`}
                content_3={`But did you know we’re a fully qualified driving school for CPC training? We’re committed to helping drivers stay up to date with safe driving practices, so if you’d like us to support your new recruits through their initial training, or ensure your experienced drivers continue to improve their skills with their periodic modules, we’re here to help. `}
                heading={``}
                imageSrc1={`/site-assets/images/our-values-1.jpg`}
                imageSrc2={`/site-assets/images/our-values-2.jpg`}
                imageSrc3={`/site-assets/images/our-values-3.jpg`}
                imageAlt1={`Our value 1`}
                imageAlt2={`Our value 2`}
                imageAlt3={`Our value 3`}
                urlSlug={`${page.url_slug}`}
                showOnDefault={false}
            />
            <SpecialismDetail
                global={global}
                pathPrefix={`client_page.specialism_detail`}
                customClass={`${page.url_slug != "cpc-training" ? "" : "mt-5 pt-5"}`}
                specialism={page}
                sub_specialisms={all_sub_specialisms}
                heading={`Some of the roles we recruit for`}
                enableSpecialismContent={true}
                brandLogo={false}
                profilePage={true}
            />
            <LatestJobs
                global={global}
                pathPrefix={`client_page.latest_jobs`}
                customClass={`my-5`}
                buttonTitle={``}
                buttonLink={``}
                heading={`${page?.title} jobs.`}
                subtitle={`jobseekers`}
                all_jobs={all_jobs}
                label={false}
                headingFullWidth={true}
                headingTextCenter={true}
                bgColor={`secondary-bg-color`}
            />
            <Clients
                global={global}
                pathPrefix={`client_page.all_clients`}
                all_clients={all_clients}
                customClass={`mt-5`}
                heading={`Accreditations and partnerships`}
            />
            <SimplePage
                global={global}
                pathPrefix={`client_page.simple_page_2`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const page = (await Collection('accreditations')).getJsonItem(params.url_slug, 'url_slug');
    // console.log(specialism.url_slug);
    const all_specialisms = await Collection('specialisms');
    const all_sub_specialisms = all_specialisms.orderBy('order')
        // Pulls parent sector only
        .filter(function (sector) {
            return (
                sector.specialism_tag?.en.includes(page.title)
            )
        }).getItems()
    // sector.specialism_tag?.en === specialism.title);
    const clients = await Collection('accreditations');
    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                // Pulls specialism sector category
                .find((cat) => cat.id === "5eac1d7e-f98e-4892-a281-29a1b974bae6")
                // ?.values?.includes(specialism.id)
                ?.values?.map(cat => cat.id).includes(page.id)
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 10);


    const all_clients = clients.orderBy('order').getItems();
    return {
        props: {
            global,
            page,
            all_clients,
            all_jobs,
            all_sub_specialisms
        },
    }
}

export async function getStaticPaths() {
    const pagePath = (await Collection('accreditations')).getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: false
    }
}